module.exports = __webpack_public_path__ + "img/icon-history.0096aab.png";